// Jednoduchý, frameworkově nezávislý event emitter pro veřejný event systém SDK
// (viz §18 zadání). Podporuje on/off/once a bezpečné doručení (chyba v jednom
// posluchači neshodí ostatní ani samotný viewer).

// Kanonický seznam veřejných událostí. Používá se pro validaci i pro dokumentaci.
export const ViewerEvents = Object.freeze([
  "viewerReady",
  "modelLoading",
  "modelLoaded",
  "modelRemoved",
  "modelVisibilityChanged",
  "selectionChanged",
  "objectClicked",
  "objectDoubleClicked",
  "visibilityChanged",
  "cameraChanged",
  "sectionChanged",
  "themeChanged",
  "error",
]);

export class EventEmitter {
  constructor() { this._map = new Map(); }

  on(event, handler) {
    if (typeof handler !== "function") return () => {};
    if (!this._map.has(event)) this._map.set(event, new Set());
    this._map.get(event).add(handler);
    return () => this.off(event, handler);
  }

  once(event, handler) {
    const wrap = (payload) => { this.off(event, wrap); handler(payload); };
    return this.on(event, wrap);
  }

  off(event, handler) {
    const set = this._map.get(event);
    if (set) { if (handler) set.delete(handler); else set.clear(); }
  }

  // Doručí událost všem posluchačům. Chyba v posluchači se pošle jako "error"
  // událost (pokud nejde přímo o "error", aby nevznikla smyčka).
  emit(event, payload) {
    const set = this._map.get(event);
    if (!set || set.size === 0) return;
    for (const h of Array.from(set)) {
      try { h(payload); }
      catch (e) {
        if (event !== "error") this.emit("error", { code: "HANDLER_ERROR", message: String(e && e.message || e), details: { event } });
        else if (typeof console !== "undefined") console.error("[IFCViewer] error handler threw", e);
      }
    }
  }

  clear() { this._map.clear(); }
}
